import React from 'react';
import CustomerOverviewTab from './CustomerOverviewTab';
import { useCustomerOverdueBalance } from './useCustomerOverdueBalance';
import Customer from '../../graphql/entities/customer/Customer';
import { useFormQuery } from '../../graphql/containers/useFormQuery';
import { EntityType } from '../../@types/entityTypes';

type ICustomerSidebarFormProps = {
  id: number;
  sidebar: boolean;
};

const CustomerSidebarForm = ({ sidebar, id }: ICustomerSidebarFormProps) => {
  const formData = useFormQuery({ instance: Customer.instance! } as EntityType, {
    duplicate: true,
    overrideParams: { id: id },
  });
  const { overdueBalance } = useCustomerOverdueBalance({ values: formData?.data });

  if (!formData?.data) {
    return null;
  }

  return (
    <CustomerOverviewTab id={id} sidebar={sidebar} values={{ ...formData.data }} overdueBalance={overdueBalance} />
  );
};

export default CustomerSidebarForm;
